(() => {
  const initialize = root => {
    root.querySelectorAll('[data-trophy-hub]').forEach(hub => {
      if (hub.dataset.ready) return;
      hub.dataset.ready = 'true';
      const dialog = hub.querySelector('dialog');
      const success = hub.querySelector('.eth__success, .eth__errors');
      if (success) success.scrollIntoView({block:'center'});
      hub.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !hub.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        history.pushState(null,'',link.hash);
        target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      });
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const large = dialog.querySelector('.eth__dialog-image img');
      const stage = dialog.querySelector('.eth__dialog-image');
      const player = dialog.querySelector('[data-trophy-player]');
      const retry = dialog.querySelector('.eth__retry');
      const controls = dialog.querySelector('.eth__dialog-controls');
      const counter = dialog.querySelector('[data-trophy-counter]');
      const thumbnails = dialog.querySelector('.eth__dialog-thumbs');
      const detail = dialog.querySelector('.eth__display-detail');
      const dialogLabel = dialog.getAttribute('aria-label');
      const cache = new Map();
      const allowPrefetch = !navigator.connection?.saveData && !['slow-2g','2g'].includes(navigator.connection?.effectiveType);
      let trigger, photos = [], index = 0, version = 0;
      const entry = link => ({type:link.dataset.mediaType||'image',label:link.dataset.label,template:link.parentElement.querySelector('[data-gallery-player]'),heading:link.dataset.detailHeading||'',detail:link.dataset.detail||'',src:link.href,mobile:link.dataset.mobile,medium:link.dataset.medium,width:Number(link.dataset.width)||1,height:Number(link.dataset.height)||1,alt:link.dataset.alt||link.querySelector('img')?.alt||'',thumbnail:link.dataset.thumbnail||link.querySelector('img')?.currentSrc});
      const rendition = photo => {
        const width = Math.min(1050,innerWidth*.96)-36;
        const height = Math.min(850,innerHeight*.94)-155;
        const pixels = Math.min(width,height*photo.width/photo.height)*Math.min(devicePixelRatio||1,2);
        return pixels <= 640 ? photo.mobile||photo.src : pixels <= 960 ? photo.medium||photo.src : photo.src;
      };
      const prepare = (photo,priority='low') => {
        if (photo.type !== 'image') return null;
        const src = rendition(photo);
        if (cache.has(src)) {
          const cached = cache.get(src);
          if (priority === 'high') cached.image.fetchPriority = 'high';
          return cached;
        }
        const image = new Image();
        const record = {image,src,loaded:false};
        image.decoding = 'async';
        image.fetchPriority = priority;
        record.promise = new Promise(resolve => {
          image.onload = async () => {
            try { await image.decode(); } catch (_) {}
            record.loaded = true;
            resolve(true);
          };
          image.onerror = () => {cache.delete(src);resolve(false);};
        });
        cache.set(src,record);
        if (cache.size > 10) cache.delete(cache.keys().next().value);
        image.src = src;
        return record;
      };
      const clearPlayer = () => {
        player.querySelectorAll('video').forEach(video => video.pause());
        player.replaceChildren();
        player.hidden = true;
      };
      const displayPhoto = next => {
        index = (next+photos.length)%photos.length;
        const current = ++version, photo = photos[index];
        const activePhotos = photos, activeIndex = index;
        clearPlayer();
        large.hidden = photo.type !== 'image';
        retry.hidden = true;
        stage.dataset.loading = 'false';
        counter.textContent = `${index+1} / ${photos.length}`;
        thumbnails.querySelectorAll('button').forEach((button,position) => {
          button.setAttribute('aria-current',position === index ? 'true' : 'false');
          if (position === index) button.scrollIntoView({block:'nearest',inline:'nearest'});
        });
        if (photo.type !== 'image') {
          if (photo.template) {
            player.append(photo.template.content.cloneNode(true));
            player.hidden = false;
            const video = player.querySelector('video');
            if (video) {
              video.autoplay = false;
              video.controls = true;
              video.playsInline = true;
              video.preload = 'none';
              video.setAttribute('aria-label',photo.alt);
              video.addEventListener('error',() => {if (current === version && dialog.open) retry.hidden = false;});
            }
          }
          return;
        }
        const request = prepare(photo,'high');
        large.alt = photo.alt;
        large.width = photo.width;
        large.height = photo.height;
        stage.dataset.loading = request.loaded ? 'false' : 'true';
        large.src = request.loaded ? request.src : photo.thumbnail||request.src;
        request.promise.then(loaded => {
          if (current !== version || !dialog.open) return;
          stage.dataset.loading = 'false';
          if (loaded) {
            large.src = request.src;
            if (allowPrefetch && activePhotos.length > 1) {
              prepare(activePhotos[(activeIndex+1)%activePhotos.length]);
              prepare(activePhotos[(activeIndex-1+activePhotos.length)%activePhotos.length]);
            }
          } else retry.hidden = false;
        });
      };
      const open = (entries,source) => {
        photos = entries;
        trigger = source;
        const explanation = entries[0].detail || '';
        dialog.classList.toggle('eth__dialog--reference',Boolean(explanation));
        detail.hidden = !explanation;
        detail.querySelector('h2').textContent = entries[0].heading || '';
        detail.querySelector('p').textContent = explanation;
        dialog.setAttribute('aria-label',explanation ? entries[0].heading : dialogLabel);
        if (explanation) dialog.setAttribute('aria-describedby',detail.id);
        else dialog.removeAttribute('aria-describedby');
        controls.hidden = photos.length < 2;
        thumbnails.hidden = photos.length < 2;
        thumbnails.replaceChildren();
        if (photos.length > 1) photos.forEach((photo,position) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label',`${photo.label||dialog.dataset.photoLabel} ${position+1}`);
          const image = document.createElement('img');
          image.src = photo.thumbnail;
          image.alt = '';
          image.width = 64;
          image.height = 64;
          image.loading = 'lazy';
          image.decoding = 'async';
          button.append(image);
          if (['video','external_video'].includes(photo.type)) {
            const badge = document.createElement('span');
            badge.className = 'eth__video-badge';
            badge.setAttribute('aria-hidden','true');
            badge.textContent = '▶';
            button.append(badge);
          }
          button.addEventListener('click',() => displayPhoto(position));
          button.addEventListener('pointerenter',() => {if (allowPrefetch) prepare(photo);});
          button.addEventListener('focus',() => {if (allowPrefetch) prepare(photo);});
          thumbnails.append(button);
        });
        dialog.showModal();
        displayPhoto(0);
      };
      const galleries = hub.querySelectorAll('[data-trophy-gallery]');
      const warm = gallery => {
        const first = gallery.querySelector('[data-gallery-entry]');
        if (allowPrefetch && first) prepare(entry(first));
      };
      const observer = allowPrefetch && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(item => {if (item.isIntersecting) {warm(item.target);observer.unobserve(item.target);}});
      },{rootMargin:'160px'}) : null;
      galleries.forEach(gallery => {
        gallery.querySelectorAll('[data-open-trophy-gallery]').forEach(button => {
          button.hidden = false;
          button.addEventListener('pointerenter',() => warm(gallery));
          button.addEventListener('focus',() => warm(gallery));
        });
        gallery.querySelector('.eth__gallery-fallback').hidden = true;
        observer?.observe(gallery);
      });
      hub.addEventListener('click',event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const button = event.target.closest('[data-open-trophy-gallery]');
        if (button) {
          const entries = [...button.closest('[data-trophy-gallery]').querySelectorAll('[data-gallery-entry]')].map(entry);
          if (entries.length) open(entries,button);
          return;
        }
        const photo = event.target.closest('[data-trophy-photo]');
        if (!photo) return;
        event.preventDefault();
        open([entry(photo)],photo);
      });
      retry.addEventListener('click',() => displayPhoto(index));
      dialog.querySelector('.eth__close').addEventListener('click',() => dialog.close());
      dialog.querySelector('.eth__dialog-prev').addEventListener('click',() => displayPhoto(index-1));
      dialog.querySelector('.eth__dialog-next').addEventListener('click',() => displayPhoto(index+1));
      dialog.addEventListener('keydown',event => {
        if (event.target.closest('video,iframe,model-viewer') || photos.length < 2 || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        displayPhoto(index+(event.key === 'ArrowRight' ? 1 : -1));
      });
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close',() => {version++;clearPlayer();if (trigger) trigger.focus({preventScroll:true});});
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();

